export var CATEGORY_MENU_WIDTH = 236;
//# sourceMappingURL=constants.js.map